<app-command [command]="update$" (success)="saved()">
  <app-details-modal title="Edit provider settings" saveLabel="Save" [form]="form" (cancel)="cancel()" (save)="save()">
    <app-details-content>

      <ng-container *appLoad="let data of load$">
        <div class="row" [formGroup]="form">
          <div class="col-12 col-md-6 col-lg-4 my-2" *ngFor="let p of data; let i = index">
            <lds-checkbox [formControlName]="p.id" [identifier]="'chk-edit' + p.id" [label]="p.name" (getChange)="toggleSelection(i)"
              [isChecked]="p.selected"></lds-checkbox>
          </div>
        </div>
      </ng-container>
    </app-details-content>
  </app-details-modal>
</app-command>